import styled from '@emotion/styled';
import useActiveNavLink from '@shared/hooks/useActiveNavLink';
import { ISubMenuItem } from '@shared/models/components/IMenuProps';
import { NavLink } from 'react-router';
import {
    MenuActiveBar,
    MenuTruncate,
    MixinMenuBaseLink,
    MixinMenuSubItemLabel,
    MixinMenuSubItemRow,
} from './CommonMenuStyles';

interface ISubMenuItemProps {
    subItem: ISubMenuItem;
}

export default function SubMenuItem({ subItem }: ISubMenuItemProps) {
    const { startMatch, exactMatch } = useActiveNavLink(subItem.href);
    const isActive =
        !subItem.activeStateMatchCriteria || subItem.activeStateMatchCriteria == 'start' ? startMatch : exactMatch;
    const matchUrlExactly = subItem.activeStateMatchCriteria == 'exact' || subItem.activeStateMatchCriteria == 'end';
    return (
        <SubmenuItem>
            <SubMenuActiveBar isActive={isActive} isSubActive={false} />
            <SubmenuLink id={subItem.id} to={subItem.href} role="menuitem" end={matchUrlExactly} viewTransition>
                <MenuTruncate>{subItem.label}</MenuTruncate>
            </SubmenuLink>
        </SubmenuItem>
    );
}

const SubmenuItem = styled.span`
    ${(props) => MixinMenuSubItemRow(props.theme)}
`;

const SubmenuLink = styled(NavLink)`
    ${MixinMenuBaseLink}
    padding: 0.5rem 0.5rem 0.5rem 40px;
    ${(props) => MixinMenuSubItemLabel(props.theme)}
`;
const SubMenuActiveBar = styled(MenuActiveBar)``;
